import { showElement } from '../../utils/dom'
import SidebarFilters from './sidebar-filters'

class SidebarFiltersMobile extends SidebarFilters {
  change(): void {
    if (this.shop) {
      this.createFilterQuery()

      this.shop.updateFiltersBySearchParams(this.searchParams)

      this.setButtonForReset()
    }
  }

  setButtonForReset(): void {
    const button = this.element.querySelector('filter-remove-btn')

    if (button) {
      const isHidden = button.classList.contains('hidden')

      if (isHidden) {
        showElement(button)
      }
    }
  }
}

export default SidebarFiltersMobile
